import {useRef, useState} from "react";
import "./index.css";
import Notification from "./notification";
import Loading from "../loading";
import {notify} from "./notification/verb";
//import {verifyEmail, postData} from "../../workers";
import {verifyEmail} from "../../workers";
import emailjs from "@emailjs/browser";

function ContactForm(){

	let nameRef = useRef();
	let mailRef = useRef();
	let bodyref = useRef();
	let mailInput = useRef();
	let messageForm = useRef();
	//all these refs re used to obtain certain elements directly so dont touc except you know what you are doing

	let [sending, setSending] = useState(false);

	const nowSendMail = function(success_text, failed_text){
		emailjs.sendForm("service_6xft7ki", "template_lre8gcr", messageForm.current, "fc6gDbInqtE9H9IgV")
		  .then((result) => {
			if(result.status === 200||201){
				notify(success_text)
				setSending(false)
			}  

		  }, (error) => {
			 // console.log(error.text);
			 notify(failed_text)
			 setTimeout(()=>setSending(false), 1200);
		  });
	};

	const sendMail = (e) => {
		e.preventDefault();
		setSending(true)
		const successtext = `Thank you ${messageForm.current.user_name.value}, I will get back to you ASAP. Enjoy the rest of the day!`
		const failtext = `Sorry ${messageForm.current.user_name.value}, something unexpected occurred, please do try again!`
		
		if (verifyEmail(messageForm.current.user_email.value)){
			nowSendMail(successtext, failtext); //this automatically sets loading to false when done !
		}else{
			notify("please check your email address again!");
			mailInput.current.focus();
			setSending(false)
		}

		
	  };

	return(
		<section id="contact-me">
			<h2 className='rock' >Leave Me a Message</h2>

			<form ref={messageForm} onSubmit={sendMail}>

				<div className='case'>
					<label htmlFor="form-name-input"> Name </label> 
					<input id="form-name-input" type='text' required={true} placeholder="e.g Joe Biden" name="user_name" onFocus={()=>nameRef.current.classList.add('up')} 
						onBlur={()=>nameRef.current.classList.remove('up')} />
					<p ref={nameRef}> This is your name </p>
				</div>


				<div className='case'>
					<label htmlFor="form-email-input"> Email </label> 
					<input id="form-email-input" ref={mailInput} type='email' required={true} placeholder="e.g sample@email.com" name="user_email" onFocus={()=>mailRef.current.classList.add('up')} 
					onBlur={()=>mailRef.current.classList.remove('up')}/>
					<p ref={mailRef}> So i can respond to your email </p>
				</div>

				<div className='non'>
					<label htmlFor="form-message-body-input"> Message </label> 
					<textarea id="form-message-body-input" required={true} placeholder="e.g Hello Ibrahim!I've seen some of your work.Great work! and I would like you to work with me on a project. What do you say?"
					onFocus={()=>bodyref.current.classList.add('up')} onBlur={()=>bodyref.current.classList.remove('up')} name="message"/>
					<p ref={bodyref}> message </p>
				</div>

				<div className="btn-gp">
					{
						sending ? <Loading /> : <input type='submit' value="Send Mail Now" className='enchanted' />
					}					
					<a href="#social-media" className="sedated"> My Social Media </a>
				</div>

			</form>			

			<Notification />

		</section>


		)
};


export default ContactForm;